export const normalizeCssSize = (size?: string | number): string | 0 => {
  if (!size) {
    return 0;
  }

  if (typeof size === "number") {
    return `${size}px`;
  }

  return size;
};

export const stopEventPropagation = (event: {
  stopPropagation: () => void;
}): void => {
  event.stopPropagation();
};

export const scheduleAfterPaint = (callbackFn: () => void): void => {
  if (typeof globalThis.requestAnimationFrame === "function") {
    globalThis.requestAnimationFrame(() => {
      globalThis.requestAnimationFrame(callbackFn);
    });

    return;
  }

  globalThis.setTimeout(callbackFn, 0);
};
